<script lang="ts">
import { useTailwind } from '@/plugins/useTailwind'
import { type PropType, defineComponent } from 'vue'

/**
 * AppPicture
 */
export default defineComponent({
  props: {
    mobile: {
      type: String,
    },
    tablet: {
      type: String,
    },
    desktop: {
      type: String,
    },
    alt: {
      type: String,
      require: true,
    },
    imgClass: {
      type: String,
      default: '',
    },
    tabletBreakpoint: {
      type: String as PropType<'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'>,
      default: 'lg',
    },
  },
  setup() {
    const tailwind = useTailwind()

    return {
      tailwindBreakpoints: tailwind.breakpoints,
    }
  },
})
</script>

<template>
  <picture class="h-full w-full">
    <source
      v-if="tablet"
      :media="`(min-width: ${tailwindBreakpoints[tabletBreakpoint]}px) and (max-width: ${tailwindBreakpoints.xl - 1}px)`"
      :srcset="tablet"
    />
    <source
      v-if="desktop"
      :media="`(min-width: ${tailwindBreakpoints.xl}px)`"
      :srcset="desktop"
    />

    <img
      :src="mobile"
      :alt
      loading="lazy"
      class="h-full w-full object-cover object-center @md/main:aspect-square @lg/main:aspect-5/4 @xl/main:aspect-16/9"
      :class="imgClass"
    />
  </picture>
</template>
